import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter} from '@angular/core';
import {trigger, state, style, animate, transition, query, keyframes, group} from '@angular/animations';
import {ApiService} from "../api.service";
import {CommonService} from "../common.service";
import {ActivatedRoute, Router} from "@angular/router";

declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-case-practice-authorization-choice',
  animations: [
    trigger('introductionBoxAnimation', [
      state('showIntroductionBox', style({transform: 'translate(0%)'})),
      state('hideIntroductionBox', style({transform: 'translate(-200%)'})),
      transition('hideIntroductionBox => showIntroductionBox', animate('200ms', keyframes([
        style({transform: 'translate(-200%)'}),
        style({transform: 'translate(-150%)'}),
        style({transform: 'translate(-100%)'}),
        style({transform: 'translate(-80%)'}),
        style({transform: 'translate(-60%)'}),
        style({transform: 'translate(-40%)'}),
        style({transform: 'translate(-20%)'}),
        style({transform: 'translate(-10%)'}),
        style({transform: 'translate(0%)'}),
      ]))),
      transition('showIntroductionBox => hideIntroductionBox', animate('200ms', keyframes([
        style({transform: 'translate(0%)'}),
        style({transform: 'translate(10%)'}),
        style({transform: 'translate(20%)'}),
        style({transform: 'translate(40%)'}),
        style({transform: 'translate(60%)'}),
        style({transform: 'translate(80%)'}),
        style({transform: 'translate(100%)'}),
        style({transform: 'translate(150%)'}),
        style({transform: 'translate(200%)'}),
      ])))
    ]),
    trigger('chatBoxAnimation', [
      transition('void => *', animate('300ms', keyframes([
        style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
        style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
        style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
        style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
        style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
        style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
        style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
        style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
        style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
        style({transform: 'scale(1, 1)', opacity: 1})
      ]))),
      transition('* => void', [
        style({opacity: 1}),
        animate('200ms', style({opacity: 0}))
      ])
    ]),
    trigger('choiceWrapAnimation', [
      state('showChoiceWrap', style({opacity: 1,display:"block"})),
      state('hideChoiceWrap', style({opacity: 0,display:"none"})),
      transition('hideChoiceWrap => showChoiceWrap', [
        style({opacity: 1}),
        group([
          query('#portraitWrap0', animate('300ms', keyframes([
            style({top: '4.7rem', left: '2.61rem'}),
            style({top: '3.975rem', left: '2.0825rem'}),
            style({top: '3.25rem', left: '1.555rem'}),
            style({top: '2.525rem', left: '1.0275rem'}),
            style({top: '1.8rem', left: '0.5rem'})
          ]))),
          query('#portraitWrap1', animate('300ms', keyframes([
            style({top: '4.7rem', left: '2.61rem'}),
            style({top: '3.975rem', left: '3.1375rem'}),
            style({top: '3.25rem', left: '3.665rem'}),
            style({top: '2.525rem', left: '4.1925rem'}),
            style({top: '1.8rem', left: '4.72rem'})

          ]))),
          query('#portraitWrap3', animate('300ms', keyframes([
            style({top: '4.7rem', left: '2.61rem'}),
            style({top: '5.28rem', left: '2.0825rem'}),
            style({top: '5.86rem', left: '1.555rem'}),
            style({top: '6.44rem', left: '1.0275rem'}),
            style({top: '7.02rem', left: '0.5rem'})

          ]))),
          query('#portraitWrap4', animate('300ms', keyframes([
            style({top: '4.7rem', left: '2.61rem'}),
            style({top: '5.28rem', left: '3.1375rem'}),
            style({top: '5.86rem', left: '3.665rem'}),
            style({top: '6.44rem', left: '4.1925rem'}),
            style({top: '7.02rem', left: '4.72rem'})
          ])))
        ])
      ]),
      transition('showChoiceWrap => hideChoiceWrap', [
        style({opacity: 1}),
        animate('200ms', style({opacity: 0}))
      ])
    ]),
    trigger('analysisWrapAnimation', [
      state("hideAnalysisWrap", style({opacity: 0})),
      state("showAnalysisWrap", style({opacity: 1})),
      transition('hideAnalysisWrap => showAnalysisWrap', animate('300ms', keyframes([
        style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
        style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
        style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
        style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
        style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
        style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
        style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
        style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
        style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
        style({transform: 'scale(1, 1)', opacity: 1})
      ]))),
      transition('showAnalysisWrap => hideAnalysisWrap', [
        style({opacity: 1}),
        animate('200ms', style({opacity: 0}))
      ]),
    ]),
    trigger('figureAnimation', [
      state("moveFigure", style({opacity: 1})),
      state("normalFigure", style({opacity: 1})),
      transition('normalFigure => moveFigure', [
        query('.activeFigure', animate('500ms', keyframes([
          style({opacity: 0.95, bottom: '0.8rem', left: '2.0rem', transform: 'scale(1)'}),
          style({opacity: 0.9, bottom: '1.2rem', left: '0.75rem', transform: 'scale(0.97)'}),
          style({opacity: 0.85, bottom: '1.6rem', left: '-0.5rem', transform: 'scale(0.95)'}),
          style({opacity: 0.8, bottom: '2rem', left: '-1rem', transform: 'scale(0.9)'}),
          style({opacity: 0.6, bottom: '2.4rem', left: '-0.5rem', transform: 'scale(0.85)'}),
          style({opacity: 0.5, bottom: '2.8rem', left: '0rem', transform: 'scale(0.8)'}),
          style({opacity: 0.5, bottom: '3.2rem', left: '0.5rem', transform: 'scale(0.7)'}),
        ])), {optional: true}),
        group([
          query('.activeFigure4', animate('500ms', keyframes([
            style({opacity: 1, bottom: '0.8rem', left: '2.0rem', transform: 'scale(1)'}),
            style({opacity: 1, bottom: '1.2rem', left: '0.75rem', transform: 'scale(0.97)'}),
            style({opacity: 1, bottom: '1.6rem', left: '-0.5rem', transform: 'scale(0.95)'}),
            style({opacity: 1, bottom: '2rem', left: '-1rem', transform: 'scale(0.9)'}),
            style({opacity: 0.9, bottom: '2.4rem', left: '-0.5rem', transform: 'scale(0.85)'}),
            style({opacity: 0.8, bottom: '2.8rem', left: '0rem', transform: 'scale(0.8)'}),
            style({opacity: 0.5, bottom: '3.2rem', left: '0.5rem', transform: 'scale(0.7)'})
          ])), {optional: true}),
          query('.activeFigure3', animate('500ms', keyframes([
            style({opacity: 0.5, bottom: '3.2rem', left: '0.5rem', transform: 'scale(0.7)'}),
            style({opacity: 0.6, bottom: '2.8rem', left: '1.5rem', transform: 'scale(0.8)'}),
            style({opacity: 0.7, bottom: '2.4rem', left: '4.75rem', transform: 'scale(0.85)'}),
            style({opacity: 0.8, bottom: '2rem', left: '6rem', transform: 'scale(0.9)'}),
            style({opacity: 0.85, bottom: '1.6rem', left: '4.75rem', transform: 'scale(0.95)'}),
            style({opacity: 0.9, bottom: '1.2rem', left: '3rem', transform: 'scale(0.97)'}),
            style({opacity: 1, bottom: '0.8rem', left: '2.25rem', transform: 'scale(1)'})
          ])), {optional: true})
        ])
      ]),
      transition('moveFigure => normalFigure', [
        query('.activeFigure2', animate('500ms', keyframes([
          style({opacity: 0.05, bottom: '3.2rem', left: '2.25rem', transform: 'scale(0.7)'}),
          style({opacity: 0.4, bottom: '2.8rem', left: '3rem', transform: 'scale(0.8)'}),
          style({opacity: 0.6, bottom: '2.4rem', left: '4.75rem', transform: 'scale(0.85)'}),
          style({opacity: 0.8, bottom: '2rem', left: '6rem', transform: 'scale(0.9)'}),
          style({opacity: 0.85, bottom: '1.6rem', left: '4.75rem', transform: 'scale(0.95)'}),
          style({opacity: 0.9, bottom: '1.2rem', left: '3rem', transform: 'scale(0.97)'}),
          style({opacity: 1, bottom: '0.8rem', left: '2.25rem', transform: 'scale(1)'}),
        ])), {optional: true}),
        group([
          query('.activeFigure3', animate('500ms', keyframes([
            style({opacity: 1, bottom: '0.8rem', left: '2.0rem', transform: 'scale(1)'}),
            style({opacity: 1, bottom: '1.2rem', left: '0.75rem', transform: 'scale(0.97)'}),
            style({opacity: 1, bottom: '1.6rem', left: '-0.5rem', transform: 'scale(0.95)'}),
            style({opacity: 1, bottom: '2rem', left: '-1rem', transform: 'scale(0.9)'}),
            style({opacity: 0.9, bottom: '2.4rem', left: '-0.5rem', transform: 'scale(0.85)'}),
            style({opacity: 0.8, bottom: '2.8rem', left: '0rem', transform: 'scale(0.8)'}),
            style({opacity: 0.5, bottom: '3.2rem', left: '0.5rem', transform: 'scale(0.7)'})
          ])), {optional: true}),
          query('.activeFigure4', animate('500ms', keyframes([
            style({opacity: 0.5, bottom: '3.2rem', left: '0.5rem', transform: 'scale(0.7)'}),
            style({opacity: 0.6, bottom: '2.8rem', left: '1.5rem', transform: 'scale(0.8)'}),
            style({opacity: 0.7, bottom: '2.4rem', left: '4.75rem', transform: 'scale(0.85)'}),
            style({opacity: 0.8, bottom: '2rem', left: '6rem', transform: 'scale(0.9)'}),
            style({opacity: 0.85, bottom: '1.6rem', left: '4.75rem', transform: 'scale(0.95)'}),
            style({opacity: 0.9, bottom: '1.2rem', left: '3rem', transform: 'scale(0.97)'}),
            style({opacity: 1, bottom: '0.8rem', left: '2.25rem', transform: 'scale(1)'})
          ])), {optional: true})
        ])
      ])
    ])
  ],
  templateUrl: './case-practice-authorization-choice.component.html',
  styleUrls: ['./case-practice-authorization-choice.component.css']
})
export class CasePracticeAuthorizationChoiceComponent implements OnInit, AfterViewInit{
  @Input() exerciseId:number;
  @Input() practiceMetaId: number;
  @Input() exerciseMetaId:number;
  @Output() onGoToNextStep = new EventEmitter<any>();

  roles: any;
  currentRole: string;
  currentDescription: string;
  currentWord: string;
  step: number;
  index: number;

  node: number;
  subNode: number;

  clickable: boolean; //可否点击
  slideable: boolean; //可否滑动
  reviewable:boolean; //可否查看

  selectedPeople: number;

  analysisText: string;

  data: any;

  authRoleId: number;

  msgCharacter: number;
  msgTimeout: any;
  reviewTimeout: any;
  // 动画
  introductionBoxShow: boolean;
  chatBoxShow: boolean;
  choiceWrapShow: boolean;
  figureShow: boolean;
  analysisWrapShow: boolean;

  stepInit: number;

  peopleViewed: number;
  peopleSubmited: number;

  taskBook: any;
  assetsRoute: string = "../../assets";

  constructor(
      private commonService:CommonService,
      private apiService: ApiService,
      private route: ActivatedRoute,
      private router: Router
  ) { }

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.apiService.ajax({
        'type': 'get',
        'url': '/api/authRole/'+this.exerciseId
    }).subscribe(result=>{
        this.data = result;
        this.roles = this.data.roles;
        this.peopleViewed = this.data.completed;
        this.peopleSubmited = this.data.status;

        if(this.peopleViewed !==0){
          for(let i = 0, len = this.roles.length; i<len; i+=1){
            this.index = this.getIndexByConditionIdInLists(this.roles,'id',this.peopleViewed);
          }
        }else{
          this.index = this.peopleViewed;
        }


        this.choicePageInit();
    });

    this.apiService.ajax({

      'type':'get',
      'url':'/api/taskBook/'+this.exerciseId

    }).subscribe(result=>{

      this.taskBook = result;

    });



    /*this.data = this.getMockData();
    this.roles = this.data.roles;
    this.peopleViewed = this.data.completed;
    this.peopleSubmited = this.data.status;


    this.choicePageInit();*/

  }

  ngAfterViewInit(){

    this.commonService.initPage({
        'backgroundColor':'white'
    });

    this.initSlideEvent();
  }

  choicePageInit(){
    this.introductionBoxShow = false;
    this.chatBoxShow = false;
    this.figureShow = false;
    this.msgCharacter = 0;
    this.msgTimeout = null;
    this.reviewTimeout = null;


    if(this.peopleSubmited==0&&this.currentRole !== '高朗'){
        this.choiceWrapShow = false;
        this.analysisWrapShow = false;
        this.clickable = false;
        this.slideable = false;
        this.reviewable = false;
        this.selectedPeople = -1;
        this.choiceInit();
        $('#wrap').css('background-image', 'url("../../assets/picture/casepracticeauthorization/bg2.png")');
    }else if(this.peopleSubmited==0&&this.currentRole === '高朗'){
        this.choiceWrapShow = true;
        this.analysisWrapShow = false;
        this.clickable = true;
        this.slideable = false;
        this.reviewable = true;
        this.selectedPeople = -1;
        this.step = 3;
        $('#wrap').css('background-image', 'url("../../assets/picture/casepracticeauthorization/bg1.png")');
    }else if(this.peopleSubmited>0){
        let _this = this;
        this.choiceWrapShow = false;
        this.clickable = false;
        this.reviewable = false;
        this.slideable = false;
        $('#choiceBtn').hide();
        let idx;
        for(let i = 0, len = this.roles.length; i<len; i+=1){
          idx = this.getIndexByConditionIdInLists(this.roles,'id',this.peopleSubmited);
        }
        this.selectedPeople = idx;
        this.currentRole = this.roles[this.selectedPeople].name;
        this.authRoleId = this.roles[this.selectedPeople].id;
        this.analysisText = this.roles[this.selectedPeople].why;
        $('#wrap').css('background-image', 'url("../../assets/picture/casepracticeauthorization/bg1.png")');

        if(this.currentRole == '高朗'){
            this.step = 202;
            $('#gl').fadeIn(200);
            this.analysisWrapShow = true;
            this.currentWord = this.roles[this.selectedPeople].why;
            this.analysisText = this.roles[this.selectedPeople].why;
            this.msgCharacter = 0;
            this.showFullText($("#analysisText"));
        }else{
            this.step = 201;
            $(this.getDomIdByName(this.currentRole)).fadeIn(200);
            $(this.getDomIdByName(this.currentRole)).addClass('activeFigure');
            this.currentWord = this.roles[this.selectedPeople].why;
            this.analysisWrapShow = true;
            this.msgCharacter = 0;
            this.showFullText($("#analysisText"));
        }
    }
  }


  taskBookOut($event){
      $event.stopPropagation();
      this.clickable = false;
      $('#shade').fadeIn(50);
      $('#taskBookBox').fadeIn();
      $('#closeBtn2').fadeIn();
  }

  closeTip($event){

      $event.stopPropagation();
      this.clickable = true;
      $('#shade').fadeOut();
      $('#taskBookBox').fadeOut();
      $('#closeBtn2').fadeOut();
      // 恢复点击功能
  }

  initSlideEvent() {

    let startX,
        startY,
        moveEndX,
        moveEndY,
        X,
        Y;

    let _this = this;
    $("#innerWrap").on("touchstart", function(e){

      startX = e.originalEvent.changedTouches[0].pageX;
      startY = e.originalEvent.changedTouches[0].pageY;

    });

    $("#innerWrap").on("touchmove", function(e){

      moveEndX = e.originalEvent.changedTouches[0].pageX;
      moveEndY = e.originalEvent.changedTouches[0].pageY;
      X = moveEndX - startX;
      Y = moveEndY - startY;

      var w = X < 0 ? X * -1 : X;     //x轴的滑动值
      var h = Y < 0 ? Y * -1 : Y;    //y轴的滑动值
      // if(w > h){
      //                  //如果是在x轴中滑动
      //   event.preventDefault();
      // }

    });
    $("#innerWrap").on("touchend", function(e){

      moveEndX = e.originalEvent.changedTouches[0].pageX;
      moveEndY = e.originalEvent.changedTouches[0].pageY;
      X = moveEndX - startX;
      Y = moveEndY - startY;

      var w = X < 0? X * -1 : X;     //x轴的滑动值
      var h = Y < 0 ? Y * -1 : Y;    //y轴的滑动值
      // if(w > h){                   //如果是在x轴中滑动
      //
      //   event.preventDefault();
      //
      // }
      if (X < -5 && w > h && _this.slideable) {

        if(_this.step == 1 || _this.step == 2){

           _this.screenClick();
        }
      }
    });
  }

  //根据条件在数组中获取下标
  getIndexByConditionIdInLists(Lists,condition,value){
    return (Lists||[]).findIndex((v)=>v[condition] === value);
  }

  // 初始化
  choiceInit(){

    let _this = this;
    this.node = this.index;
    console.log(this.node);
    this.subNode = 0;

    this.currentRole = this.roles[this.node].name;
    this.currentDescription = this.roles[this.node].description;
    this.currentWord = this.roles[this.node].say[this.subNode];
    this.step = 1;
    setTimeout(function(){

      $(_this.getDomIdByName(_this.currentRole)).fadeIn(200);
      _this.introductionBoxShow = true;

    }, 500);

    setTimeout(function(){

      // $('#arrowRight').fadeIn(200);
      _this.clickable = true;
      _this.slideable = true;

    }, 1500);

  }

  screenClick(){
  	//多对话继续
  	if(this.dialogPause){
  		this.dialogPause = false;
  		return false;
  	}
    // console.log(this.step);
    if(!this.clickable){
      return;
    }
    let _this = this;
    this.msgCharacter = 0;
    if(this.step == 1){
      this.clickable = false;
      this.slideable = false;
      // this.step = 2;
      this.introductionBoxShow = false;
      // $('#arrowRight').fadeOut(200);
      this.chatBoxShow = true;
      setTimeout(function(){
        // 显示第一句动画
        _this.getLetterByLetter($(_this.getDomIdByName(_this.currentRole) + 'ChatText'));
      }, 500);
    }else if(this.step == 2){
      this.clickable = false;
      this.slideable = false;
      let lastRoleDomId = this.getDomIdByName(this.currentRole);
      $(lastRoleDomId).fadeOut(200);
      this.chatBoxShow = false;
      // $("#arrowRight").fadeOut(200);
      // 清空文字
      $(this.getDomIdByName(this.currentRole) + 'ChatText').text("");
        this.apiService.ajax({
            'type':'post',
            'url':'/api/authRoleRead/'+this.exerciseId,
            'data':{
                'authrole_id':this.roles[this.node].id
            }
        }).subscribe(result=>{});
      // 换人了
      if(this.node < this.roles.length-1){
        this.step = 1;
        this.node++;
        this.currentWord = this.roles[this.node].say[this.subNode];
        this.currentRole = this.roles[this.node].name;
        this.currentDescription = this.roles[this.node].description;
        // $(lastRoleDomId+'Chat').fadeOut(200);
        setTimeout(function () {
          $(_this.getDomIdByName(_this.currentRole)).fadeIn(200);
          // $('#introductionBox').fadeIn(200);
          _this.introductionBoxShow = true;
        }, 500);
        setTimeout(function(){
          // $("#arrowRight").fadeIn(200);
          _this.clickable = true;
          _this.slideable = true;
        }, 1500);
      }else{
        this.step = 3;
        setTimeout(function () {
          // $("#arrowRight").fadeOut(200);
          _this.choiceWrapShow = true;
          $('#wrap').css('background-image', 'url("../../assets/picture/casepracticeauthorization/bg1.png")');
          $('.portraitBtn').css('z-index', 10000);
        },500);
        setTimeout(function(){
          _this.clickable = true;
          _this.slideable = false;
          _this.reviewable = true;
        }, 1500);
      }
    }else if(this.step == 101){
      this.clickable = false;
      this.reviewable = false;
      this.introductionBoxShow = false;
      this.chatBoxShow = true;
      setTimeout(function(){
        _this.getLetterByLetter($(_this.getDomIdByName(_this.currentRole) + "ChatText"));
      }, 500);
    }
  }

  peopleReview(i){

    if(!this.clickable || !this.reviewable){
        return;
    }
    let _this = this;
    this.clickable = false;
    this.msgCharacter = 0;
    $('#numberWrap').fadeOut(10);
    // $('#choiceWrap').fadeOut(200)
    this.choiceWrapShow = false;
    this.node = i;
    this.subNode = 0;
    this.currentRole = this.roles[this.node].name;
    this.currentDescription = this.roles[this.node].description;
    this.currentWord = this.roles[this.node].say[this.subNode];
    this.step = 101;
    setTimeout(function(){
      $(_this.getDomIdByName(_this.currentRole)).fadeIn(200);
      _this.introductionBoxShow = true;
      $('#closeBtn').fadeIn(200);
    },500);
    this.reviewTimeout = setTimeout(function(){
      _this.introductionBoxShow = false;
      _this.chatBoxShow = true;
      setTimeout(function(){
        _this.getLetterByLetter($(_this.getDomIdByName(_this.currentRole) + "ChatText"));
      }, 500);
    }, 1500);
  }

  selectPeople($event,i){
    $event.stopPropagation();
    if(!this.clickable || !this.reviewable){
      return;
    }
    this.selectedPeople = i;
  }

  close($event){
    $event.stopPropagation();
    let _this = this,
        lastRoleDomId = this.getDomIdByName(this.currentRole);
    clearTimeout(this.msgTimeout);
    clearTimeout(this.reviewTimeout);
    this.clickable = false;
    // this.slideable = false;
    this.step = 3;
    $(lastRoleDomId).fadeOut(200);
    $(lastRoleDomId+'Chat').fadeOut(200);
    $(this.getDomIdByName(lastRoleDomId) + "ChatText").text("")
    $('#closeBtn').fadeOut(200);
    $('#numberWrap').fadeIn(200);
    // $('#introductionBox').fadeOut(200);
    this.introductionBoxShow = false;
    this.chatBoxShow = false;
    setTimeout(function(){
      _this.choiceWrapShow = true;
    }, 500);
    setTimeout(function(){
      _this.clickable = true;
    }, 1500);
  }

  submitSelectedPeople($event){
		this.peopleClick = true;
    let _this = this;
    $event.stopPropagation();
    if(this.selectedPeople < 0){
      return;
    }
    this.clickable = false;
    this.reviewable = false;
    this.choiceWrapShow = false;
    this.currentRole = this.roles[this.selectedPeople].name;
    this.authRoleId = this.roles[this.selectedPeople].id;
    this.analysisText = this.roles[this.selectedPeople].why;
    this.choiceWrapShow = false;
    $('#choiceBtn').hide();
    this.msgCharacter = 0;
    $('.portraitBtn').css('z-index', 1);
    if(this.currentRole == '高朗'){
      this.step = 202;
      $('#gl').fadeIn(200);
      this.analysisWrapShow = true;
      this.currentWord = this.roles[this.selectedPeople].why;
      this.analysisText = this.roles[this.selectedPeople].why;
      this.msgCharacter = 0;
      this.getLetterByLetter($("#analysisText"));
    }else{
      this.step = 201;
      $(this.getDomIdByName(this.currentRole)).fadeIn(200);
      $(this.getDomIdByName(this.currentRole)).addClass('activeFigure');
      this.currentWord = this.roles[this.selectedPeople].why;
      this.analysisWrapShow = true;
      this.msgCharacter = 0;
      this.getLetterByLetter($("#analysisText"));
    }
    this.apiService.ajax({

      'type':'post',
      'url':'/api/authRole/'+this.exerciseId,
      'data':{
          'authrole_id':this.authRoleId
      }

    }).subscribe(result=>{});

  }
  //选人之后 个人头像才可以点击
	peopleClick:boolean = false;
  switchFigure($event){
  	if(this.peopleClick){
	  	if(!this.figureShow && $event.target.className.indexOf("activeFigure4") > -1){
	    	return false;
	    }else if(this.figureShow && $event.target.className.indexOf("activeFigure3") > -1){
	    	return false;
	    }
	    let _this = this;
	    clearTimeout(this.msgTimeout);
	    this.msgCharacter = 0;
	    this.figureShow = !this.figureShow;
	    $("#analysisTextBox").fadeOut(200);
	    $("#analysisText").text("");
	    // this.analysisWrapShow = false;

	    setTimeout(function(){

	      if(_this.figureShow){

	        _this.currentWord = _this.roles[_this.selectedPeople].why;
	        _this.analysisText = _this.currentWord;
	        $("#analysisTextBox").fadeIn(200);
	        $('.activeFigure4').css({opacity: 0.5, bottom: '3.2rem', left: '0.5rem', transform: 'scale(0.7)'}).css('z-index', 9998);
	        $('.activeFigure3').css({opacity: 1, bottom: '0.8rem', left: '2.25rem', transform: 'scale(1)'}).css('z-index', 9999);

	      }else if(!_this.figureShow){

	        _this.currentWord = _this.roles[_this.selectedPeople].correct;
	        _this.analysisText = _this.currentWord;
	        $("#analysisTextBox").fadeIn(200);
	        $('.activeFigure3').css({opacity: 0.5, bottom: '3.2rem', left: '0.5rem', transform: 'scale(0.7)'}).css('z-index', 9998);
	        $('.activeFigure4').css({opacity: 1, bottom: '0.8rem', left: '2.25rem', transform: 'scale(1)'}).css('z-index', 9999);

	      }
				_this.showFullText($("#analysisText"));
    }, 500);
		}
  }

  goToQuestion($event){
    this.commonService.setOnceIno(this.commonService.getOnceValue(this.exerciseMetaId,703)).subscribe();
    this.onGoToNextStep.emit(4);
  }

  getDomIdByName(name){
      if(name=='秦飞'){
          return '#qf'
      }else if(name=='季宁'){
          return '#jn'
      }else if(name=='王立娜'){
          return '#wln'
      }else if(name=='方科科'){
          return '#fkk'
      }else if(name=='高朗'){
          return '#gl'
      }
  }
  //多对话 暂停
  dialogPause:boolean = false;
  getLetterByLetter(container){
    let _this = this;
    this.msgTimeout = setTimeout(function(){
    	if(_this.dialogPause){
    		_this.getLetterByLetter(container);
    	}else{
    		if(_this.currentWord.substring(_this.msgCharacter, _this.msgCharacter + 1) == "<"){
	        _this.msgCharacter+=5;
	      } else{
	        _this.msgCharacter++;
	      }
	      var type = _this.currentWord.substring(0, _this.msgCharacter);
	      container.html(type);
	      _this.getLetterByLetter(container);
    	}

      if (_this.msgCharacter == _this.currentWord.length){
        if(_this.step == 201){
          clearTimeout(_this.msgTimeout);
          setTimeout(function(){
            _this.step = 202;
            _this.currentWord = _this.roles[_this.selectedPeople].correct;
            _this.msgCharacter = 0;
            _this.analysisWrapShow = false;
            container.text("");
            $('#gl').addClass("activeFigure2");
            // _this.figureShow = true;
            setTimeout(function(){
              // $('#gl').fadeIn(200);
              _this.analysisText = _this.roles[_this.selectedPeople].correct;
              _this.figureShow = true;
              _this.analysisWrapShow = true;
            }, 1000);
            setTimeout(function(){
              $('.activeFigure').css({opacity: 0.5, bottom: '3.2rem', left: '0.5rem', transform: 'scale(0.7)'}).css('z-index', 9998);
              $('#gl').fadeIn();
              $('.activeFigure2').css('z-index', 9999);
              _this.figureShow = false;
            }, 1500);
            setTimeout(function(){
              _this.showFullText($("#analysisText"));
              $('#reviewCommentBtn').fadeIn(200);
              $('.activeFigure').removeClass('activeFigure').addClass('activeFigure3');
              $('.activeFigure2').removeClass('activeFigure2').addClass('activeFigure4');
            }, 2000);
          }, 1000);
        }else if(_this.step == 202){
          clearTimeout(_this.msgTimeout);
          setTimeout(function(){
            $('#analysisBtn').fadeIn(200);
          }, 500);
          _this.step = 203;
       }else if(_this.step == 203){
          clearTimeout(_this.msgTimeout);
          // _this.clickable = true;
       }else if(_this.subNode < _this.roles[_this.node].say.length - 1){
         	 _this.dialogPause = true;
           _this.subNode ++;
           _this.currentWord = _this.roles[_this.node].say[_this.subNode];
           _this.msgCharacter = 0;
       }else{
          clearTimeout(_this.msgTimeout);
          if(_this.step == 1){
            _this.step = 2;
            setTimeout(function(){
              _this.subNode = 0;
              _this.msgCharacter = 0;
              // $('#arrowRight').fadeIn(200);
              _this.slideable = true;
              _this.clickable = true;
            }, 1000);
          }else if(_this.step == 101){
            _this.step = 102;
            setTimeout(function(){
              let lastRoleDomId = _this.getDomIdByName(_this.currentRole);
              $(lastRoleDomId).fadeOut(200);
              $(lastRoleDomId+'Chat').fadeOut(200);
              _this.chatBoxShow = false;
              setTimeout(function(){
                container.text("");
                _this.choiceWrapShow = true;
                $('#closeBtn').fadeOut(200);
              },500);
              setTimeout(function(){
                _this.clickable = true;
                _this.reviewable = true;
                $('#numberWrap').fadeIn(200);
              }, 1500);
            }, 1000);
          } // end of 101
        } // end of role equal
      } // end of if letter is finished
    }, 20); // end of setTimeout
  } // end of getLetterByLetter

	showFullText(container) {
		clearTimeout(this.msgTimeout);
		container.html(this.currentWord);
		var _this = this;
		//显示授权按钮
		if(this.step == 202){
      setTimeout(function(){
        $('#analysisBtn').fadeIn(200);
      }, 500);
      this.step = 203;
   	}else if(this.step == 201){
   		setTimeout(function(){

   			//copy show
   			_this.step = 202;
   		  _this.currentWord = _this.roles[_this.selectedPeople].correct;
        _this.msgCharacter = 0;
        _this.analysisWrapShow = false;
        container.text("");
        $('#gl').addClass("activeFigure2");
        // _this.figureShow = true;
        setTimeout(function(){
          // $('#gl').fadeIn(200);
          _this.analysisText = _this.roles[_this.selectedPeople].correct;
          _this.figureShow = true;
          _this.analysisWrapShow = true;
        }, 1000);
        setTimeout(function(){
          $('.activeFigure').css({opacity: 0.5, bottom: '3.2rem', left: '0.5rem', transform: 'scale(0.7)'}).css('z-index', 9998);
          $('#gl').fadeIn();
          $('.activeFigure2').css('z-index', 9999);
          _this.figureShow = false;
        }, 1500);
        setTimeout(function(){
          _this.showFullText($("#analysisText"));
          $('#reviewCommentBtn').fadeIn(200);
          $('.activeFigure').removeClass('activeFigure').addClass('activeFigure3');
          $('.activeFigure2').removeClass('activeFigure2').addClass('activeFigure4');
        }, 2000);
       },1000);
   	}
	}
}



// WEBPACK FOOTER //
// ./src/app/case-practice-authorization-choice/case-practice-authorization-choice.component.ts